import { getOwner } from "@ember/application"
import { action, get, set } from "@ember/object"
import Route from "@ember/routing/route"
import { later, scheduleOnce } from "@ember/runloop"
import { inject as service } from "@ember/service"
import { isNone } from "@ember/utils"
import { easeIn, easeOut } from "ember-animated/easings/cosine"
import move from "ember-animated/motions/move"
import { fadeIn, fadeOut } from "ember-animated/motions/opacity"

export default class EditRoute extends Route {
  @service("ember-store")
  store

  @service
  modalManager;

  *transition({ insertedSprites, keptSprites, removedSprites }) {
    insertedSprites.forEach((sprite) => {
      sprite.startAtPixel({ x: window.innerWidth })
      move(sprite, { easing: easeOut, duration: 150 })
      fadeIn(sprite, { easing: easeOut, duration: 150 })
    })

    keptSprites.forEach(move)

    removedSprites.forEach((sprite) => {
      sprite.endAtPixel({ x: window.innerWidth })
      move(sprite, { easing: easeIn, duration: 150 })
      fadeOut(sprite, { easing: easeIn, duration: 150 })
    })
  }

  model(params) {
    let transition = function* ({ insertedSprites, keptSprites, removedSprites }) {
      insertedSprites.forEach((sprite) => {
        sprite.startAtPixel({ x: window.innerWidth })
        move(sprite, { easing: easeOut, duration: 150 })
        fadeIn(sprite, { easing: easeOut, duration: 150 })
      })

      keptSprites.forEach(move)

      removedSprites.forEach((sprite) => {
        sprite.endAtPixel({ x: window.innerWidth })
        move(sprite, { easing: easeIn, duration: 150 })
        fadeOut(sprite, { easing: easeIn, duration: 150 })
      })
    }
    // alert("showScreen: false")
    return this.modelFor("new-group.show")
    //
    // return new Ember.RSVP.Promise(resolve => {
    //   get(this, "store")
    //     .find("group", params.id)
    //     .then(group => {
    //       console.log("group", group)
    //       resolve({
    //         group: group,
    //         transition: transition,
    //         showScreen: true
    //       })
    //     })
    // })
  }

  afterModel(model) {
    later(() => {
      // alert("showScreen: true")
      get(this, "modalManager").openModalOutsideManager()
      set(model, "showScreen", true)
    }, 50)
    // get(this, "modalManager").openModal("school/setup", {
    //   school: get(this, "model")
    // })
  }

  deactivate() {
    get(this, "modalManager").closeModalOutsideManager()
    // get(this, "modalManager").closeModal("school/setup")
  }

  @action
  didTransition() {
    // BLOGGABLE TRICK
    scheduleOnce("afterRender", () => {
      let applicationController = getOwner(this).lookup("controller:application")
      let currentRouteName = get(applicationController, "currentRouteName")
      let group = get(this, "currentModel")
      if (currentRouteName === "new-group.show.edit.index") {
        // If it's a school network...
        if (group.attributes.usedAs === "school-network") {
          if (
            // ...we want to prevent them from getting to the "Add Teachers" screen at all and instead take them to the "Add Admins" screen
            isNone(this.lastRouteVisited) ||
            this.lastRouteVisited === "new-group.show.edit.members" ||
            this.lastRouteVisited === "new-group.show.edit.members.index"
          ) {
            this.lastRouteVisited = "new-group.show.edit.admins"
          }
          // ... but if it's NOT a school network...
        } else {
          if (
            // ... we want to prevent them from getting to the "Add Admins" screen at all and instead take them to the "Add Teachers" screen.
            isNone(this.lastRouteVisited) ||
            this.lastRouteVisited === "new-group.show.edit.admins" ||
            this.lastRouteVisited === "new-group.show.edit.admins.index"
          ) {
            this.lastRouteVisited = "new-group.show.edit.members"
          }
        }
        this.replaceWith(this.lastRouteVisited)
      } else {
        this.lastRouteVisited = currentRouteName
      }
    })
  }
}
